/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Whtr_Band_Note_HealthyInputs */

const en_us2_body_assessment_whtr_band_note_healthy = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_HealthyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your waist is between 40% and 50% of your height, which is where NICE puts the lowest cardiometabolic risk.`)
};

const pt_br2_body_assessment_whtr_band_note_healthy = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_HealthyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sua cintura está entre 40% e 50% da altura, que é onde o NICE coloca o menor risco cardiometabólico.`)
};

const es_419_body_assessment_whtr_band_note_healthy = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_HealthyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cintura está entre el 40% y el 50% de tu estatura, que es donde el NICE ubica el menor riesgo cardiometabólico.`)
};

const pt_pt2_body_assessment_whtr_band_note_healthy = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_HealthyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua cintura está entre 40% e 50% da altura, que é onde o NICE situa o menor risco cardiometabólico.`)
};

const fr_fr2_body_assessment_whtr_band_note_healthy = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_HealthyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton tour de taille est entre 40 % et 50 % de ta hauteur, là où le NICE situe le risque cardiométabolique le plus bas.`)
};

const de_de2_body_assessment_whtr_band_note_healthy = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_HealthyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Taille liegt zwischen 40 % und 50 % deiner Größe, wo NICE das niedrigste kardiometabolische Risiko verortet.`)
};

const it_it2_body_assessment_whtr_band_note_healthy = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_HealthyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua vita è tra il 40% e il 50% dell'altezza, dove il NICE colloca il rischio cardiometabolico più basso.`)
};

/**
* | output |
* | --- |
* | "Your waist is between 40% and 50% of your height, which is where NICE puts the lowest cardiometabolic risk." |
*
* @param {Body_Assessment_Whtr_Band_Note_HealthyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_whtr_band_note_healthy = /** @type {((inputs?: Body_Assessment_Whtr_Band_Note_HealthyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Whtr_Band_Note_HealthyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_whtr_band_note_healthy(inputs)
	if (locale === "es-419") return es_419_body_assessment_whtr_band_note_healthy(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_whtr_band_note_healthy(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_whtr_band_note_healthy(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_whtr_band_note_healthy(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_whtr_band_note_healthy(inputs)
	return en_us2_body_assessment_whtr_band_note_healthy(inputs)
});
export { body_assessment_whtr_band_note_healthy as "body-assessment.whtr_band_note.healthy" }